import {__contacontabil_endpoints} from "@components/contaContabil/endpoints/__contacontabil_endpoints.js";
import type {IContaContabil} from "@models/contaContabil/contaContabil.js";
import React from "react";
import {DefaultConsumerPesquisaAutoProps, DefaultPesquisaAuto} from "@shared/specialComponents/DefaultPesquisaAuto.tsx";
import type {IContasContabeisFiltroDto} from "@models/contaContabil/createContaContabilDto.ts";

interface ContaContabilPesquisaProps extends DefaultConsumerPesquisaAutoProps<IContaContabil, IContasContabeisFiltroDto> {
}

export function ContaContabilPesquisa(props: ContaContabilPesquisaProps) {
    const handleItemSelected = (item: IContaContabil | undefined) => {
        if (props.onItemSelected) {
            props.onItemSelected(item);
        }
    };

    const handleFormat = (conta: IContaContabil) => `${conta.nomeCompletoFormatado} ${conta.nome} - ${conta.id}`;

    return (
        <DefaultPesquisaAuto<IContaContabil, IContasContabeisFiltroDto>
            endpoint={__contacontabil_endpoints['v2']["get-contas-contabeis"]} // Pass the API function
            searchField={'search'}
            itemToString={handleFormat}   // Pass the formatting function
            onItemSelected={handleItemSelected} // Pass the selection handler
            display={{
                name: "Conta Contabil"
            }}
            {...props}
        />
    );
};